import React from 'react'

export default function NPOSAccountInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
      `}
      </style>
    </React.Fragment>
  )
}
